class OffCanvasMenu extends HTMLElement {
  constructor () {
    super()

    this.classNames = {
      menuLeft: 'offcanvas--left',
      menuPush: 'offcanvas--push',
      isOpen: 'is-offcanvas-open',
      isPush: 'is-offcanvas-push',
      isPushLeft: 'is-offcanvas-push-left',
    }

    this.hidden = true
    this.addDimmer()
    this.initControls()
  }

  initControls () {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())

    this.closeButtons = this.querySelectorAll('button[name="close"]')
    this.closeButtons.forEach(b =>
      b.addEventListener('click', this.close.bind(this)),
    )

    this.toggleButtons = document.querySelectorAll(`a[href="#${this.id}"], [data-menu-toggle="${this.id}"]`)
    this.toggleButtons.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggle()
      })
    })
  }

  open (origin) {
    const openClasses = [this.classNames.isOpen]

    if (!this.hidden) {
      return
    }

    window.theme?.noscroll?.apply()

    if (this.classList.contains(this.classNames.menuPush)) {
      openClasses.push(this.classNames.isPush)
      if (this.classList.contains(this.classNames.menuLeft)) {
        openClasses.push(this.classNames.isPushLeft)
      }
    }

    this.addEventListener('transitionend', () => {
      this.focus()
      window.trapFocus(this)
    }, { once: true })

    this.dimmer.hidden = false
    this.hidden = false

    window.requestAnimationFrame(() => {
      this.classList.add('is-active')
      document.body.classList.add(...openClasses)
    })

    const eventActionDetails = { action: 'open', origin: origin.localName }
    this.createOffCanvasMenuEvent('fostrOffCanvasMenuEvent', this, eventActionDetails)
  }

  close () {
    if (this.hidden) {
      return
    }

    window.theme?.noscroll?.remove()

    document.body.classList.remove(
      this.classNames.isOpen,
      this.classNames.isPush,
      this.classNames.isPushLeft,
    )

    this.addEventListener('transitionend', () => {
      this.hidden = true
      this.dimmer.hidden = true
      window.removeTrapFocus(this.activeElement)
      const eventActionDetails = { action: 'close', type: 'click' }
      this.createOffCanvasMenuEvent('fostrOffCanvasMenuEvent', this, eventActionDetails)
    }, { once: true })
    this.classList.remove('is-active')
  }

  toggle () {
    if (this.hidden) {
      this.closeAllMenus()
      this.open(this)
    } else {
      this.close()
    }
  }

  addDimmer () {
    this.dimmer = document.querySelector('.offcanvas-dimmer')
    if (this.dimmer) {
      return
    }
    this.dimmer = document.createElement('div')
    this.dimmer.classList.add('offcanvas-dimmer')
    document.body.appendChild(this.dimmer)
    this.dimmer.addEventListener('click', this.closeAllMenus)
  }

  closeAllMenus () {
    document.querySelectorAll('offcanvas-menu').forEach(menu => {
      menu.close()
    })
  }

  createOffCanvasMenuEvent (eventType, HTMLObject, details) {
    const fostrOffCanvasMenuEvent = new CustomEvent(eventType, {
      detail: {
        menuHTMLObject: this,
        action: details.action,
        origin: details.origin || '',
      },
    })

    // dispatch the events
    window.document.dispatchEvent(fostrOffCanvasMenuEvent)
  }
}

customElements.define('offcanvas-menu', OffCanvasMenu)
